export default {
  methods: {
    isPointInCircle(a, b, cirX, cirY, cirRad) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("%c isPointInCircle", "color:lime", {
          a,
          b,
          cirX,
          cirY,
          cirRad,
        });
      var dist_points = Math.sqrt(
        (a - cirX) * (a - cirX) + (b - cirY) * (b - cirY)
      );
      if (dist_points < cirRad) {
        return true;
      }
      return false;
    },
    dateToYMD(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1; //Month from 0 to 11
      var y = date.getFullYear();
      return (
        "" + y + "-" + (m <= 9 ? "0" + m : m) + "-" + (d <= 9 ? "0" + d : d)
      ); //YYYY-MM-DD
    },
    updateTemplate(template, valueObj) {
      template = template.replace("{{PersonalId}}", valueObj.personalId);
      template = template.replace("{{Mobile}}", valueObj.mobile);
      template = template.replace("{{Name}}", valueObj.name);
      template = template.replace(
        "{{Classification}}",
        valueObj.classification
      );
      return template;
    },
  },
};
